import script from "./BriefcaseHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BriefcaseHeader.vue?vue&type=script&setup=true&lang=js"

import "./BriefcaseHeader.vue?vue&type=style&index=0&id=406825ce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-406825ce"]])

export default __exports__